import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";

import SubawardDashboard from "containers/Subaward/Dashboard";
import SubawardListView from "containers/Subaward/List";
import { COLUMN_HEADER_KEYS, SUBAWARDS_LIST_DEFAULT_COLUMNS } from "globals/constants";
import { useColumnHeaders, useFacetedSearch } from "hooks";
import { setSubawardSearchBar } from "store/actions/subawardList";
import { subawardListSelectors } from "store/selectors";

import styles from "./styles.css";


const SubawardsMainView = () => {
	const SUBAWARDS_LIST_ID = "subawardsTable";

	const { columnHeaders: availableColumns, defaultColumnHeaders, dashboardColumnHeaders } =
		useColumnHeaders(COLUMN_HEADER_KEYS.SUBAWARD, {
			defaultColumnHeaders: SUBAWARDS_LIST_DEFAULT_COLUMNS
		});

	const { searchFacets, onSearchChange } = useFacetedSearch({
		availableColumns: dashboardColumnHeaders,
		setSearchFragments: setSubawardSearchBar,
	});

	const search = useSelector(subawardListSelectors.search);
	const [ actualFacets, setActualFacets ] = useState({});


	useEffect(()=>{
		const reduxSearch = { ...search };
		const selectedFacets = {};
		Object.keys(reduxSearch).forEach((searchKey) => {
			const facet = searchFacets.find((facet) => facet.searchKey === searchKey);
			if (facet) {
				selectedFacets[facet.key] = reduxSearch[searchKey];
			}
		});
		setActualFacets(selectedFacets);
	},[ search, searchFacets ]);

	return (
		<div id="view-main-subawards" className={styles.viewMainSubawards}>
			<SubawardDashboard dashboardTilesAriaControls={SUBAWARDS_LIST_ID} searchFacets={searchFacets}
				onSearchChange={onSearchChange} actualFacets={actualFacets}
			/>
			<SubawardListView subawardsListId={SUBAWARDS_LIST_ID}
				searchFacets={searchFacets} onSearchChange={onSearchChange} availableColumns={availableColumns}
				defaultColumnHeaders={defaultColumnHeaders} actualFacets={actualFacets}
			/>
		</div>
	);
};

export default SubawardsMainView;
